module.exports = __webpack_public_path__ + "static/media/siri20.69689881.jpg";